<template>
  <div class="pay-success" v-loading="submitLoading">
    <!-- 支付信息 -->
    <div class="pay-info">
      <div class="ptitle_row flex-row">
        <span class="blod">开店申请提交成功，请您扫码支付店铺年服务费</span>
      </div>
      <div class="ptitle_box flex-row padding-20">
        <span
          >支付金额(元)：<span style="color: red">￥{{ cost }}</span></span
        >
      </div>
      <div class="ptitle_row flex-row">
        <span class="blod">请选择付款方式</span>
      </div>
      <div class="ptitle_row flex-row" style="justify-content: flex-start">
        <div
          class="pay-way flex-row-start"
          :class="{ 'pay-way-selected': payWayType === 2 }"
          @click="payTypeChange(2)"
        >
          <img style="margin: 0 15px" src="./img/wx.png" alt="" />
          <div class="flex-col way-content" style="align-items: flex-start">
            <span class="font-style-normal">微信支付</span>
            <span class="font-style-normal-2">推荐使用，方便快捷</span>
          </div>
        </div>
        <div
          class="pay-way flex-row-start"
          :class="{ 'pay-way-selected': payWayType === 4 }"
          @click="payTypeChange(4)"
        >
          <img style="margin: 0 15px" src="./img/zz.png" alt="" />
          <div class="flex-col way-content" style="align-items: flex-start">
            <span class="font-style-normal">公对公转账汇款</span>
            <span class="font-style-normal-2"
              >通过银行线下汇款的方式转账购买</span
            >
          </div>
        </div>
      </div>
      <!-- 微信支付内容 -->
      <div v-show="payWayType == 2">
        <div class="flex-col" v-if="isPaySuccess">
          <img
            src="./img/success.png"
            alt=""
            style="width: 79px; height: 79px; margin-top: 60px"
          />
          <span style="margin: 30px 0 228px 0; font-size: 24px; color: #4a4a4a"
            >提交成功</span
          >
        </div>
        <div class="qrcode flex-col" v-else>
          <div class="qrcode-subtitle">
            打开<span style="color: #ff142f;">微信APP</span> 首页-右上角扫一扫
            <i
              class="el-icon-full-screen"
              style="margin-left: 4px; color: #999;"
            ></i>
          </div>
          <div class="qrcode-main">
            <div class="img-box" v-loading="isLoading">
              <img
                v-if="url"
                :src="url"
                alt=""
                style="width: 276px; height: 276px; object-fit: contain"
              />
              <div v-if="payTime <= 0" class="qrcode-invalid-overlay">
                <div class="invalid-text">二维码已失效</div>
                <div class="reget-btn" @click="reloimg">重新获取</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 公对公支付内容 -->
      <div v-show="payWayType != 2">
        <div class="flex-col" v-if="isPaySuccess">
          <img
            src="./img/success.png"
            alt=""
            style="width: 79px; height: 79px; margin-top: 60px"
          />
          <span style="margin: 30px 0 228px 0; font-size: 24px; color: #4a4a4a"
            >提交成功</span
          >
        </div>
        <publicToPublic v-else ref="ptp" />
      </div>
      <div
        style="display: flex; justify-content:space-between;"
        v-if="showBtn && payWayType === 4 && !isPaySuccess"
      >
        <div
          class="combtn data-bottom-btn"
          style="width: 230px;"
          @click="handelTijaio()"
        >
          提交
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import publicToPublic from "./components/publicToPublic.vue";
import {
  queryPingAnPayUrl,
  query,
  billPay
} from "@/views/lessor-open-shop/api.js";
import { deepClone } from "@/utils";

export default {
  components: { publicToPublic },
  props: {
    supInfo: {
      type: Object,
      default: () => ({
        billCodes: [],
        billIds: [],
        phone: "",
        wxAppUserId: ""
      })
    }
  },
  data() {
    return {
      isLoading: false,
      payTime: 90,
      url: "",
      isPaySuccess: false,
      timel: null,
      payWayType: 2, // weixin 2 gdg 4
      showBtn: true, //是否展示提交按钮
      timer1: null,
      timer2: null,
      submitLoading: false
    };
  },
  computed: {
    cost() {
      const o = window.location;
      const hostname = o.hostname;
      const regex = /^([^-\s]*)/;
      const match = hostname.match(regex);
      switch (match[1]) {
        case "dev01": {
          return 0.01;
        }
        case "test01": {
          return 0.01;
        }
        case "uat01": {
          return 0.01;
        }
        default: {
          return 3000;
        }
      }
    },
  },
  mounted() {
    if(this.supInfo.billCodes.length && this.supInfo.billIds.length){
      this.getQRCode();
    }
  },
  methods: {
    // 处理刷新
    reloimg() {
      if (this.isLoading) return;
      this.getQRCode();
    },
    clearTimers() {
      if (this.timer1) {
        clearInterval(this.timer1);
        this.timer1 = null;
      }
      if (this.timer2) {
        clearInterval(this.timer2);
        this.timer2 = null;
      }
    },
    getQRCode() {
      this.isLoading = true;
      try {
        let params = {
          orderCodes: this.supInfo.billCodes || [],
          orderCodeSerial: "支付",
          frontSkipUrl:
            "https://test01-zlxt.iccec.cn/serviceCharge/billingManageList",
          phone: this.supInfo.phone || "",
          wxAppUserId: this.supInfo.wxAppUserId || "",
        };
        queryPingAnPayUrl(params).then(res => {
          let { code } = res.data;
          if (code === "0") {
            this.url = res.data.data.imageUrl;
            this.clearTimers();
            this.payTime = 90;
            this.isLoading = false;
            this.timer1 = setInterval(() => {
              this.payTime--;
              if (this.payTime <= 0) {
                this.clearTimers();
              }
            }, 1000);
            this.timer2 = setInterval(() => {
              this.queryData();
            }, 3000);
          }
        });
      } catch (error) {
        console.error("生成二维码失败:", error);
      }
    },
    queryData() {
      let params = {
        orderCodes: this.supInfo.billCodes
      };
      if (this.isPaySuccess) return;
      query(params).then(res => {
        let { code } = res.data;
        if (code === "0") {
          this.queryObj = res.data.data;
          if (res.data.data.allPay === 1) {
            this.$message({
              message: "支付成功！",
              type: "success"
            });
            this.paySuccess();
          }
        }
      });
      console.log(this.queryObj, "queryData");
    },
    paySuccess() {
      this.isPaySuccess = true;
    },
    payTypeChange(type) {
      if (this.isPaySuccess) return;
      this.payWayType = type;
    },
    async validateForm() {
      const res = await this.$refs.ptp.validateForm();
      return res;
    },
    async handelTijaio() {
      const res = deepClone(await this.validateForm());
      if (!res) return;

      let params = {
        billCode: this.supInfo.billCodes[0],
        billId: this.supInfo.billIds[0],
        ...res,
        payMoney: this.cost,
        payType: 2,
        isShowLoading: true
      };
      console.log(params, "formData");
      this.submitLoading = true;
      billPay(params)
        .then(res => {
          let { code } = res.data;
          if (code === "0") {
            this.$message({
              showClose: true,
              message: "支付成功！",
              ccuiCustom: true,
              offset: document.documentElement.clientHeight / 2 - 21,
              type: "success"
            });
            this.paySuccess();
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.pay-success /deep/.el-submitLoading-spinner {
  margin-top: 0;
  margin-left: 0;
  transform: translate(-50%, -50%);
}
.flex-col,
.pay-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.pay-info {
  padding: 20px;
  width: 80%;
  background: #fff;
  border-radius: 8px;
  margin: 20px auto;
}
.flex-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex-row-start {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.ptitle {
  color: #4a4a4a;
  font-size: 20px;
  margin-bottom: 20px;
  .success_img {
    width: 40px;
    height: 40px;
    margin: 0 10px;
  }
}
.ptitle_row {
  width: calc(100% - 40px);
  margin: 0 20px 20px 20px;
  color: #4a4a4a;
  font-size: 20px;
  .success_img {
    width: 40px;
    height: 40px;
    margin: 0 10px;
  }
}
.qrcode {
  width: 100%;
  // border-top: 1px solid #f2f2f2;
  margin-top: 20px;
  padding: 20px 0;
  .qrcode-subtitle {
    font-size: 14px;
    color: #999;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  }
  .qrcode-main {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
  }
  .img-box {
    width: 296px;
    height: 296px;
    border-radius: 8px;
    border: 1px solid #e9e9e9;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
  }
  .qrcode-invalid-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    .invalid-text {
      font-size: 16px;
      margin-bottom: 12px;
      font-weight: 500;
    }
    .reget-btn {
      background: #ff142f;
      color: #fff;
      padding: 8px 24px;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
    }
  }
}
.blod {
  font-weight: 600;
}
.text-red {
  color: #ff142f;
}
.ptitle_box {
  width: calc(100% - 80px);
  margin: 0 20px 20px 20px;
  height: 70px;
  font-size: 16px;
  background: #f9fafb;
  border-radius: 8px;
}
.padding-20 {
  padding: 0 20px;
}
.pay-way {
  width: 400px;
  height: 70px;
  border-radius: 8px;
  border: 1px solid #f1f1f1;
  margin-right: 40px;
  cursor: pointer;
  .way-content {
    font-family: PingFangSC, PingFang SC;
    color: #4a4a4a;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    margin: 0 15px;
    .font-style-normal {
      font-weight: 500;
      font-size: 16px;
    }
    .font-style-normal-2 {
      color: #999999;
      font-weight: 400;
      font-size: 14px;
    }
  }
}
.pay-way-selected {
  border: 1px solid #ff142f;
}
.copy-btn {
  padding: 0 7px;
  height: 25px;
  border-color: red;
  color: red;
}
.combtn {
  margin: 20px 0;
  font-family: PingFangSC-Semibold, PingFangSC;
  font-size: 13px;
}
.data-bottom-btn {
  background: red;
  width: 500px;
  height: 40px;
  border-radius: 4px;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  user-select: none;
  &:hover {
    background: #f50b25;
  }
}
</style>
